module.exports = __webpack_public_path__ + "img/currency-ethereum-circle.17dc04b2.svg";